<script setup lang="ts">
  import FormField from '@/components/form/FormField.vue';
  import FormCheckbox from '@/components/form/FormCheckbox.vue';
  import { useLegalDocumentStore } from '@/stores/legal-document-store';

  const emit = defineEmits(['submit']);

  const localePath = useLocalePath();

  const { fields, isSuccess, isError, onSubmit } = useLeaveForm(emit);

  const { getDocumentSlugForAlias } = useLegalDocumentStore();
</script>

<template>
  <div class="leave-form">
    <div
      v-if="isSuccess"
      class="form-message form-message--success">
      {{ $t('chat.form.success') }}
    </div>
    <div
      v-if="isError"
      class="form-message form-message--error">
      {{ $t('chat.form.error') }}
    </div>
    <form
      novalidate
      @submit.prevent="onSubmit">
      <div class="leave-form-block">
        <FormField v-bind="fields.name" />
        <FormField v-bind="fields.companyName" />
        <FormField v-bind="fields.email" />
        <FormField v-bind="fields.phone" />
      </div>
      <div class="leave-form-block">
        <FormCheckbox
          name="consentPrivacyPolicy"
          :checked-value="true"
          rules="required">
          <i18n-t
            keypath="chat.form.consentPrivacyPolicy"
            scope="global">
            <template #linkText>
              <NuxtLink
                :to="localePath({ name: 'documents-dslug', params: { dslug: getDocumentSlugForAlias('privacyPolicyContact') } })"
                target="_blank"
                class="text-magenta font-medium">
                {{ $t('chat.form.consentPrivacyPolicyLinkText') }}
              </NuxtLink>
            </template>
          </i18n-t>
          &nbsp;*
        </FormCheckbox>
      </div>
      <div class="leave-form-block">
        <button class="leave-form-submit">
          {{ $t('chat.form.submit') }}
        </button>
      </div>
    </form>
  </div>
</template>
